import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { useParams } from 'react-router-dom';
import SidebarAdmin from '../layout/SidebarAdmin';
import { getRegistroEventoAgenda } from '../../actions/agenda';

const EventoAgendaStatistiche = ({ auth: { user, loading }, alert, getRegistroEventoAgenda, agenda: { evento } }) => {

  let { idEvento } = useParams();

  useEffect(() => {
    getRegistroEventoAgenda({ idEvento });
  }, [idEvento, getRegistroEventoAgenda]);

  if (loading || !evento) {
    return <Spinner />;
  }

  const participants = evento.participants?.results || [];

  // 📊 Statistiche
  const totalePartecipanti = participants.length;
  const durataPartecipanti = participants.map(p => {
    const joined = new Date(p.joinedAt);
    const left = new Date(p.leftAt);
    return Math.round((left - joined) / 1000 / 60); // minuti
  });
  const durataMedia = durataPartecipanti.reduce((a, b) => a + b, 0) / (durataPartecipanti.length || 1);

  // 🧑‍🤝‍🧑 Distinguo host da ospiti
  const host = participants.find(p => p.roleName === "host");
  const ospiti = participants.filter(p => p.roleName !== "host");

  return (loading ? <Spinner /> :
    <section className="fd-section wide">
      <div className="w-layout-blockcontainer fd-container null w-container">
        <div className="fd-wrap backend">
          <SidebarAdmin />
          <div>
            <div>
              <div className="w-layout-blockcontainer fd-container backend w-container">
                <div className="fd-wrap">
                  <div className="w100">
                {/* INFO EVENTO */}
                <div className="evento-info">
                  <h2><strong>Titolo: </strong>{evento.evento.titolo}</h2>
                  <p><strong>Descrizione: </strong>{evento.evento.descrizione}</p>
                  <p><strong>Data:</strong> {new Date(evento.evento.data).toLocaleDateString()} - {evento.evento.orario}</p>
                </div>

                {/* STATISTICHE */}
                <h3>Statistiche</h3>
                <div className="statistiche">
                  <p><strong>Totale partecipanti:</strong> {totalePartecipanti}</p>
                  <p><strong>Durata media:</strong> {Math.round(durataMedia)} minuti</p>
                  {host && <p><strong>Host:</strong> {host.displayName}</p>}

                {/* LISTA PARTECIPANTI */}
                <div className="partecipanti">
                  <h3>Partecipanti</h3>
                  <table className="statistiche-table">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Entrata</th>
                        <th>Uscita</th>
                        <th>Durata (min)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {participants.map((p, i) => {
                        const joined = new Date(p.joinedAt);
                        const left = new Date(p.leftAt);
                        const durata = Math.round((left - joined) / 1000 / 60);
                        return (
                          <tr key={i}>
                            <td>{p.displayName}</td>
                            <td>{joined.toLocaleTimeString()}</td>
                            <td>{left.toLocaleTimeString()}</td>
                            <td>{durata}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                </div>
              </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

EventoAgendaStatistiche.propTypes = {
  auth: PropTypes.object.isRequired,
  agenda: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  getRegistroEventoAgenda: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  auth: state.auth,
  alert: state.alert,
  agenda: state.agenda
});

export default connect(mapStateToProps, { getRegistroEventoAgenda })(EventoAgendaStatistiche);